// extracted by mini-css-extract-plugin
export default {"SalariesPage":"SalariesPage_SalariesPage__ssiqi"};